import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/components/MainLayout'

Vue.use(Router)

export const defaultRouter = [
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  }
]

export const asyncRouter = [
  {
    path: '/',
    component: MainLayout,
    redirect: '/Dashboard',
    meta: { name: 'Dashboard', icon: 'bank' },
    children: [
      {
        path: '/Dashboard',
        name: 'Dashboard',
        meta: { name: '首页' },
        hidden: false,
        component: () => import('@/views/dashboard/index')
      }
    ]
  },
  {
    path: '/MessageCenterMenu',
    component: MainLayout,
    meta: { name: '消息中心', icon: 'message', alwaysShow: true },
    children: [
      {
        path: '/my-message',
        name: 'MyMessage',
        meta: { name: '我的消息' },
        component: () => import('@/views/message-center/my-message/index.vue')
      },
      {
        path: '/todo-workbench',
        name: 'TodoWorkbench',
        meta: { name: '待办工作台' },
        component: () => import('@/views/message-center/todo-workbench/index.vue')
      }
    ]
  },
  {
    path: '/CreateNoticeMenu',
    component: MainLayout,
    meta: { name: '通知管理', icon: 'profile', permission: ['admin', 'dev'] },
    children: [
      {
        path: '/NoticeManage',
        name: 'NoticeManage',
        meta: { name: '发布通知管理' },
        component: () => import('@/views/notice-manage/index')
      },
      {
        path: '/CreateNotice',
        name: 'CreateNotice',
        hidden: true,
        meta: { name: '创建通知' },
        component: () => import('@/views/create-notice/index')
      },
      {
        path: '/DocManage',
        name: 'DocManage',
        meta: { name: '文档管理' },
        component: () => import('@/views/doc-manage/index')
      },
      {
        path: '/DocEdit',
        name: 'DocEdit',
        hidden: true,
        meta: { name: '文档编辑' },
        component: () => import('@/views/doc-edit/index')
      },
      {
        path: '/DocumentView/:id',
        name: 'DocumentView',
        hidden: true,
        meta: { name: '文档编辑' },
        component: () => import('@/views/document-view/index')
      }
    ]
  },
  {
    path: '/ChannelTemplateMenu',
    component: MainLayout,
    meta: { name: '通道与模板', icon: 'setting', permission: ['admin', 'dev'] },
    children: [
      {
        path: '/configuration',
        name: 'configuration',
        meta: { name: '通道配置' },
        component: () => import('@/views/channel-template/channel/index')
      },
      {
        path: '/TemplateManage',
        name: 'TemplateManage',
        meta: { name: '模板管理' },
        component: () => import('@/views/channel-template/template/index')
      },
      {
        path: '/CreateTemplate',
        name: 'CreateTemplate',
        hidden: true,
        meta: { name: '创建模板' },
        component: () => import('@/views/channel-template/template-create/index')
      },
      {
        path: '/CreateChannel',
        name: 'CreateChannel',
        hidden: true,
        meta: { name: '创建通道' },
        component: () => import('@/views/channel-template/channel-create/index')
      },
      {
        path: '/ChannelGroupManage',
        name: 'ChannelGroupManage',
        meta: {
          name: '通道组管理',
          permission: ['admin', 'dev']
        },
        component: () => import('@/views/channel-template/channel-group/index')
      },
      {
        path: '/CreateChannelGroup',
        name: 'CreateChannelGroup',
        hidden: true,
        meta: { name: '创建通道组' },
        component: () => import('@/views/channel-template/channel-group-create/index')
      },
      {
        path: '/message-group-manager',
        name: 'MessageGroupManage',
        meta: {
          name: '消息组管理',
          permission: ['admin', 'dev']
        },
        component: () => import('@/views/channel-template/message-group-manager/index')
      },
      {
        path: '/todo-category',
        name: 'TodoCategory',
        meta: {
          name: '待办分类管理',
          permission: ['admin', 'dev']
        },
        component: () => import('@/views/channel-template/todo-category/index')
      },
      {
        path: '/notice-history-detail/:id',
        name: 'NoticeHistoryDetail',
        meta: { name: '通知历史详情' },
        hidden: true,
        component: () => import('@/views/notice-history-detail/index')
      }
    ]
  },
  {
    path: '/MonitorCenterMenu',
    component: MainLayout,
    meta: { name: '监控中心', icon: 'eye', alwaysShow: true, permission: ['admin', 'dev'] },
    children: [
      {
        path: '/notice-history',
        name: 'NoticeHistory',
        meta: { name: '通知历史' },
        component: () => import('@/views/monitor-center/notice-history/index.vue')
      },
      {
        path: '/event-log',
        name: 'EventLog',
        meta: { name: '事件日志' },
        component: () => import('@/views/monitor-center/event-log/index.vue')
      },
      {
        path: '/event-type',
        name: 'EventType',
        meta: { name: '事件类型' },
        component: () => import('@/views/monitor-center/event-type/index.vue')
      },
      {
        path: '/todo-list',
        name: 'TodoList',
        meta: { name: '待办列表' },
        component: () => import('@/views/monitor-center/todo-list/index.vue')
      },
      {
        path: '/statistic-report',
        name: 'StatisticReport',
        meta: { name: '统计报表' },
        component: () => import('@/views/monitor-center/statistic-report/index.vue')
      }
    ]
  },
  {
    path: '/ContactMenu',
    component: MainLayout,
    meta: { name: '通讯录', icon: 'team', alwaysShow: true },
    children: [
      {
        path: '/Contact',
        name: 'Contact',
        meta: { name: '员工列表' },
        component: () => import('@/views/contact/index')
      }
    ]
  },
  {
    path: '/SystemToolsMenu',
    component: MainLayout,
    meta: { name: '系统工具', icon: 'tool', alwaysShow: true },
    children: [
      {
        path: '/export-async-task',
        name: 'export-async-task',
        meta: { name: '异步导出任务' },
        component: () => import('@/views/system-tools/index')
      }
    ]
  },
  {
    path: '/DeveloperCenterMenu',
    component: MainLayout,
    meta: { name: '开发者中心', icon: 'code', permission: ['admin', 'dev'] },
    children: [
      {
        path: '/Token',
        name: 'Token',
        meta: { name: 'API Token' },
        component: () => import('@/views/developer-center/index')
      },
      {
        path: '/ApiDoc',
        name: 'ApiDoc',
        meta: { name: '接入文档' },
        component: () => import('@/views/developer-center/api-doc')
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: defaultRouter,
    mode: 'history'
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
